import React, { useEffect, useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import { Assignment } from '@material-ui/icons';
import { FormControl, InputLabel, MenuItem, Select, TextField } from '@material-ui/core';

import { onlyMoney } from 'hooks/Pipe';
import { wsCreate, wsGet, wsGetAll } from 'services/WService';
import { ConstantPermissions } from 'contexts/useConstant';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import Groups from './Grups';
import { Autocomplete } from '@material-ui/lab';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
    fontWeight: '500'
  }
});

const groupsArticles = [
  { type: 'M', label: 'MASIVO' },
  { type: 'F', label: 'EXTRAS - PROD. FOCO' }
];

const defaultData = {
  incentive_type: 'M'
};

export default function Provider(props) {
  const classes = useStyles();
  const { incentive, showNotify, reload } = props;

  const [providerInc, setProviderInc] = useState(defaultData);
  const [filterGropDetails, setFilterGroupDetails] = useState([]);
  const [gProviders, setGProviders] = useState([]);

  const handleChange = (e) => {
    setProviderInc({ ...providerInc, [e.target.name]: e.target.value });
  };

  async function listGProviders() {
    let response = await wsGetAll('com/provider-group');
    if (response.success) setGProviders(response.data);
  }

  async function getGroupDetails(idGroupP) {
    let response = await wsGet('com/provider-group', idGroupP);
    if (response.success && providerInc.item_type != undefined)
      setFilterGroupDetails(response.data?.details);
  }

  async function saveProviderInc() {
    let data = { ...providerInc };
    if (providerInc.incentive_type === 'M') {
      data = {
        com_provider_group_id: providerInc.com_provider_group_id,
        min_range: data.min_range,
        max_range: data.max_range,
        incentive_type: data.incentive_type
      };
    }

    let response = await wsCreate(`com/incentive/${incentive.id}/provider`, data);
    if (response.success) {
      showNotify(response.message);
      setProviderInc({});
      setProviderInc(defaultData);
      reload();
    } else {
      showNotify(response.message, 'error');
    }
  }

  useEffect(() => {
    listGProviders();
  }, []);

  useEffect(() => {
    if (providerInc.item_type) getGroupDetails(providerInc.com_provider_group_id);
  }, [providerInc.item_type]);

  return (
    <Card>
      <CardHeader icon>
        <CardIcon color="primary" pointer="true">
          <Assignment />
        </CardIcon>
        <h4 className={classes.cardIconTitle}>Datos de proveedor: por definir</h4>
      </CardHeader>
      <CardBody>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            saveProviderInc();
          }}
        >
          <GridContainer>
            <GridItem xs={12} md={3} lg={2}>
              <FormControl fullWidth margin="normal" size="small" required>
                <InputLabel>Tipo incentivo</InputLabel>
                <Select
                  value={providerInc.incentive_type || ''}
                  inputProps={{
                    name: 'incentive_type',
                    onChange: handleChange
                  }}
                >
                  <MenuItem value="M">Masivo</MenuItem>
                  <MenuItem value="F">Focalizado</MenuItem>
                </Select>
              </FormControl>
            </GridItem>

            <GridItem xs={12} md={3} lg={2}>
              <TextField
                label="Rango mínimo"
                type="number"
                name="min_range"
                value={providerInc.min_range || ''}
                onChange={handleChange}
                onKeyPress={onlyMoney}
                inputProps={{ min: 0, max: providerInc.max_range, step: 0.01 }}
                margin="normal"
                size="small"
                fullWidth
              />
            </GridItem>
            <GridItem xs={12} md={3} lg={2}>
              <TextField
                label="Rango máximo"
                type="number"
                name="max_range"
                value={providerInc.max_range || ''}
                onChange={handleChange}
                onKeyPress={onlyMoney}
                inputProps={{ min: providerInc.min_range, step: 0.01 }}
                margin="normal"
                size="small"
                fullWidth
              />
            </GridItem>
            {providerInc.incentive_type === 'F' ? (
              <GridItem xs={12} md={3} lg={2}>
                <FormControl fullWidth margin="normal" size="small" required>
                  <InputLabel>Tipo Artículo</InputLabel>
                  <Select
                    value={providerInc.item_type || ''}
                    inputProps={{
                      name: 'item_type',
                      onChange: handleChange
                    }}
                  >
                    <MenuItem value="L">Línea</MenuItem>
                    <MenuItem value="F">Familia</MenuItem>
                    {/* <MenuItem value="S">Subfamilia</MenuItem> */}
                    <MenuItem value="P">Producto</MenuItem>
                  </Select>
                </FormControl>
              </GridItem>
            ) : undefined}

            <GridItem xs={12} md={3} lg={2}>
              <Autocomplete
                key={providerInc.incentive_type}
                disableClearable
                options={gProviders}
                getOptionLabel={(option) => option.description}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Grupo proveedor"
                    margin="normal"
                    size="small"
                    required
                  />
                )}
                onChange={(e, item) => {
                  setProviderInc({ ...providerInc, com_provider_group_id: item.id });
                  if (providerInc.incentive_type === 'F') getGroupDetails(item.id);
                }}
                disabled={providerInc.item_type == undefined && providerInc.incentive_type === 'F'}
              />
            </GridItem>

            {providerInc.incentive_type === 'F' &&
            providerInc.com_provider_group_id != undefined ? (
              <GridItem xs={12} md={3} lg={2}>
                <Autocomplete
                  key={
                    providerInc.incentive_type +
                    providerInc.item_type +
                    providerInc.com_provider_group_id
                  }
                  disableClearable
                  options={
                    filterGropDetails?.filter((item) => item.item_type === providerInc.item_type) ||
                    []
                  }
                  getOptionLabel={(option) => option.item_description}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        providerInc.item_type === 'L'
                          ? 'Línea'
                          : providerInc.item_type === 'F'
                          ? 'Familia'
                          : providerInc.item_type === 'P'
                          ? 'Producto'
                          : 'Tipo'
                      }
                      margin="normal"
                      size="small"
                      required
                    />
                  )}
                  onChange={(e, item) => setProviderInc({ ...providerInc, item_id: item.id })}
                />
              </GridItem>
            ) : undefined}

            <GridItem xs={12} md={12} lg={12}>
              <AllowedGuard permission={ConstantPermissions.LOGI_MARKS_SHOW}>
                <Button
                  type="submit"
                  color="success"
                  style={{ float: 'right', marginBottom: '20px' }}
                >
                  Guardar
                </Button>
              </AllowedGuard>
            </GridItem>
            <GridItem xs={12} md={12} lg={12}>
              <hr style={{ padding: 0, margin: '0px 0px 12px 0px' }} />
            </GridItem>
          </GridContainer>
        </form>
        <div>
          {groupsArticles.map((item, i) => (
            <div key={i}>
              <Groups
                incentive={incentive}
                data={incentive?.providers?.filter((p) => p.incentive_type === item.type)}
                groupType={item}
                showNotify={showNotify}
                reload={reload}
              />
            </div>
          ))}
        </div>
      </CardBody>
    </Card>
  );
}
